import createActions from "../actionsGenerator";
import {getSdbBalanceSettingsState} from "./selectors";
import {SDB_ENABLED_SET, SDB_EXCEPTION_USERS_SET, SDB_MINIMAL_VALUE_SET, SDB_USER_EXCEPTION_TYPE_SET} from "./actionTypes";

const actions = createActions({
    actions: {
        ENABLED_SET: SDB_ENABLED_SET,
        MINIMAL_VALUE_SET: SDB_MINIMAL_VALUE_SET,
        USER_EXCEPTION_TYPE_SET: SDB_USER_EXCEPTION_TYPE_SET,
        EXCEPTION_USERS_SET: SDB_EXCEPTION_USERS_SET
    },
    getStateSelector: getSdbBalanceSettingsState,
    onChangeEvent: "sdbLowBalanceSettings_changed"
})

export default actions



// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/sdb/actions.js